// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"eaaf49f3","769":"83d6c7fe"}[chunkId] + ".chunk.js";
};